import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DailyLogService } from '../daily-log.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-daily-log-detail',
  templateUrl: './daily-log-detail.component.html',
  styleUrls: ['./daily-log-detail.component.scss']
})
export class DailyLogDetailComponent implements OnInit {
  project_id: any;
  // bid_ext_id: any;
  projectDetail: any;
  logDetail:any;
  displayedColumns: string[] = ['log_title', 'log_description', 'created_at', 'action'];
  user_type:number;
  user_id:string;
  isFranchisee:boolean=false;
  constructor(private route: ActivatedRoute, private router:Router,private dlService: DailyLogService,private commonService:CommonService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe((query:any)=>{
      console.log(query);
      this.project_id=query?.project_id;
      this.user_id=query?.user_id;
      this.user_type=query?.type;
    })
    this.getViewDailyLog();
    this.isFranchisee=this.commonService.isFranchisee;
  }

  getViewDailyLog() {
    this.dlService.getViewDailyLogs(this.project_id,this.user_id,this.user_type).subscribe(data => {
      console.log("data",data)
      this.logDetail = data?.userLogs;
    }, error => {
      console.log(error);
    })
  }
  back() {
    this.router.navigate(['/project/daily-logs'],{queryParams:{
      id:this.project_id
    }})
  }
  redirectOnView(item){
    console.log(item);
    this.router.navigate(['/project/daily-logs/single-daily-log'],{queryParams:{
      daily_log_id:item?.daily_log_id,
      type:item?.type,
      project_id:this.project_id,
      user_id:this.user_id
    }})
  }
}
